App.controller('ZochBillListCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaSalaryBillService', '$timeout', '$stateParams', 'Blob', 'FileSaver', 'profileService', '$rootScope', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaSalaryBillService, $timeout, $stateParams, Blob, FileSaver, profileService, $rootScope) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_bill';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Lista rachunków';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    $scope.bills = [];

    $scope.download = function (value) {
        zochaSalaryBillService.getFile(value.id).then(function (response) {
            var data = new Blob([response.data], {type: 'application/pdf'});
            FileSaver.saveAs(data, 'Rachunek_' + value.id + '.pdf');
        })
    };

    $scope.stats = {
        enteredDeclarations: 0,
        ownedDeclarations: 0,
        amount: 0,
    };

    if ($rootScope.CONFIGURATOR.zoch.isBillListEnabled) {
        zochaSalaryBillService.dataList({
            pageNumber: 0,
            pageSize: 1000000,
        }).then(function (success) {
            // var data = [
            //     {
            //         "billDownloaded": true,
            //         "billDownloadedDate": "2018-12-05T14:05:32.309Z",
            //         "creationTime": "2018-12-05T14:05:32.310Z",
            //         "enteredDeclarations": 0,
            //         "id": 0,
            //         "lifeInsuranceSum": 0,
            //         "month": 0,
            //         "ownedDeclarations": 0,
            //         "readyDeclarations": 0,
            //         "salary": 0,
            //         "userId": 0,
            //         "year": 0
            //     }
            // ];
            var data = success.data.data;

            $scope.bills = data;
            var stats = angular.copy($scope.stats);

            data.forEach(function (single) {
                stats.enteredDeclarations += single.enteredDeclarations;
                stats.ownedDeclarations += single.ownedDeclarations;
                stats.amount += single.salary;
            });

            $scope.stats = stats;

            console.log('[ZochBillListCtrl] dataList', data, 'stats', stats);
        });
    }
}]);
